import { useFormik } from "formik";
import * as Yup from "yup";
import { useEffect, useState } from "react";
import { useAuth } from "../../Providers/AuthProvider";
import { toast } from "react-toastify";
import InfoUserForm from "./InfoUserForm";
import { getUserInfoService } from "../../services/getUserInfoService";
import { PersonsUpdateService } from "../../services/PersonsUpdateService";
import ChangePassword from "../ChangePassword/ChangePassword";
import { Modal } from "@mui/material";
import { Box } from "@mui/system";
import "animate.css";
import TrackVisibility from "react-on-screen";
import ContentLoading from "../Loading/Loading";

const InfoUser = () => {
  const [loading, setLoading] = useState(true);
  const [submitTracker, setSubmitTracker] = useState(0);
  const [userInfo, setUserInfo] = useState({
    Id: "",
    FirstName: "",
    LastName: "",
    Email: "",
    MobileNumber: "",
    FatherName: "",
    BirthDate: "",
    NationalityCode: "",
    PhoneNumber: "",
    Gender: "",
  });
  const { stateAuth } = useAuth();
  const [openModalChangePass, setOpenModalChangePass] = useState(false);
  const handleOpenModalChangePass = () => setOpenModalChangePass(true);
  const handleCloseModalChangePass = () => setOpenModalChangePass(false);

  useEffect(() => {
    const getUserInfo = async () => {
      const header = {
        headers: {
          token: stateAuth,
        },
      };
      try {
        const { data } = await getUserInfoService(header);
        setUserInfo({
          Id: data.Id,
          FirstName: data.FirstName,
          LastName: data.LastName,
          Email: data.Email,
          MobileNumber: data.MobileNumber,
          FatherName: data.FatherName,
          BirthDate: data.BirthDate,
          NationalityCode: data.NationalityCode,
          PhoneNumber: data.PhoneNumber,
          Gender: data.Gender,
        });
        setLoading(false);
        formik.resetForm();
      } catch (error) {
        console.log(error);
      }
    };
    getUserInfo();
  }, [submitTracker]);
  const initialValues = {
    FirstNameSR: userInfo.FirstName,
    LastNameSR: userInfo.LastName,
    Email: userInfo.Email,
    MobileNumber: userInfo.MobileNumber,
    FatherNameSR: userInfo.FatherName,
    BirthDate: userInfo.BirthDate,
    NationalityCode: userInfo.NationalityCode,
    PhoneNumber: userInfo.PhoneNumber,
    Gender:
      userInfo.Gender === 0
        ? { value: "0", label: "مرد" }
        : { value: "1", label: "زن" },
  };

  const validationSchema = Yup.object({
    FirstNameSR: Yup.string().required("لطفا نام خود را وارد نمایید."),
    LastNameSR: Yup.string().required("لطفا نام‌خانوادگی خود را وارد نمایید."),
    Email: Yup.string()
      .required("لطفا ایمیل خود را وارد نمایید.")
      .email("ایمیل وارد شده نامعتبر میباشد."),
    MobileNumber: Yup.string()
      .required("لطفا تلفن همراه خود را وارد نمایید.")
      .matches(/^[0-9]{11}$/, "شماره وارد شده نامعتبر میباشد.")
      .nullable(),
    FatherNameSR: Yup.string().required("لطفا نام پدر خود را وارد نمایید."),
    BirthDate: Yup.string().required("لطفا تاریخ تولد خود را وارد نمایید."),
    NationalityCode: Yup.string()
      .required("لطفا کد ملی خود را وارد نمایید.")
      .matches(/^[0-9]{10}$/, "کد ملی وارد شده نامعتبر میباشد.")
      .nullable(),
    PhoneNumber: Yup.string()
      .required("لطفا تلفن ثابت خود را وارد نمایید.")
      .matches(/^[0-9]{11}$/, "شماره وارد شده نامعتبر میباشد.")
      .nullable(),
    Gender: Yup.object().required("لطفا جنسیت خود را وارد نمایید."),
  });
  const userGenderOption = [
    { value: "0", label: "مرد" },
    { value: "1", label: "زن" },
  ];

  const onSubmit = async (values) => {
    const {
      FirstNameSR,
      LastNameSR,
      Email,
      MobileNumber,
      FatherNameSR,
      BirthDate,
      NationalityCode,
      PhoneNumber,
      Gender,
    } = values;
    const userData = {
      person: {
        Id: userInfo.Id,
        FirstNameSR,
        LastNameSR,
        Email,
        MobileNumber,
        FatherNameSR,
        BirthDate,
        NationalityCode,
        PhoneNumber,
        Gender: Gender.value,
      },
      TitleSR: "",
    };
    try {
      const header = {
        headers: {
          token: stateAuth,
        },
      };
      const { data } = await PersonsUpdateService(userData, header);
      toast.success(`اطلاعات حساب کاربری با موفقیت بروزرسانی شد.`);
      setLoading(true);
      setSubmitTracker(submitTracker + 1);
      formik.resetForm();
    } catch (error) {
      if (error.response && error.response.data.message) {
        //setError(error.response.data.message);
        toast.error(error);
      }
    }
  };

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit,
    validationSchema,
    validateOnMount: true,
    enableReinitialize: true,
  });
  return loading ? (
    <ContentLoading />
  ) : (
    <TrackVisibility once>
      {({ isVisible }) =>
        isVisible && (
          <div className="p-5 shadow-lg rounded-md border border-stone-100 bg-white animate__animated animate__fadeIn">
            <form
              className="flex flex-wrap justify-start"
              onSubmit={formik.handleSubmit}
            >
              <InfoUserForm
                formik={formik}
                userGenderOption={userGenderOption}
                handleOpenModal={handleOpenModalChangePass}
              />
            </form>
            <Modal
              open={openModalChangePass}
              onClose={handleCloseModalChangePass}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box className="absolute top-1/2 -translate-y-1/2 bg-white mx-auto left-0 right-0 w-11/12 md:w-1/3 p-4 rounded-xl">
                <ChangePassword handleCloseModal={handleCloseModalChangePass} />
              </Box>
            </Modal>
          </div>
        )
      }
    </TrackVisibility>
  );
};

export default InfoUser;
